<div class="diagnostics-steps">
  <div class="vm-container">
    <div class="diagnostics-steps__heading">
      <div class="vm-col-xs-12">
        <vm-page-heading [routerLinkText]="backLabel" [isDefault]="true" vmRemoveFromView></vm-page-heading>
      </div>
    </div>
  </div>

  <div class="vm-container">
    <div class="diagnostics-steps__content diagnostics-steps__vertical-center">
      <div class="vm-col-xs-12 vm-col-sm-12 vm-col-md-8 vm-col-lg-12 full-flex">
        <vm-carousel
          (slideEvent)="onSlide($event)"
          (doneButtonClick)="onCarouselDone()"
          (backButtonClick)="onCarouselBack()">
          <ng-container *ngFor="let item of items">
            <vm-carousel-slide
              *vmCarouselSlide
              [media]="item?.media"
              [title]="item?.title"
              [subtitle]="item?.subtitle"
              [description]="item.description"
              [actions]="item?.actions"
              [modal]="item?.modalObj"
              (next)="onNext($event)"
              (modalNext)="onModalNext($event)"></vm-carousel-slide>
          </ng-container>
        </vm-carousel>
      </div>
    </div>
  </div>
</div>
